import { redirect } from "@tanstack/react-router";

/**
 * Route-level admin gate. Throws a TanStack Router redirect to the
 * given fallback path when the active-company route context flags the
 * caller as non-admin. Use from a `beforeLoad`:
 *
 * ```ts
 * beforeLoad: ({ context, params }) => {
 *   requireAdmin(context, params.companySlug);
 * }
 * ```
 *
 * The fallback defaults to `/${slug}/reports` — the only path
 * non-admins are allowed inside a company today.
 */
export function requireAdmin(
  context: { isAdmin?: boolean },
  companySlug: string,
  fallback: string = `/${companySlug}/reports`,
): void {
  if (!context.isAdmin) {
    throw redirect({ to: fallback });
  }
}
